"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M8.5 17a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1zM8 14.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5m.5-3.5a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1z"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M7.5 3A2.5 2.5 0 0 0 5 5.5v13A2.5 2.5 0 0 0 7.5 21h9a2.5 2.5 0 0 0 2.5-2.5v-11a.5.5 0 0 0-.146-.354l-4-4A.5.5 0 0 0 14.5 3zM6 5.5A1.5 1.5 0 0 1 7.5 4H14v2.5A1.5 1.5 0 0 0 15.5 8H18v10.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 6 18.5zM17.293 7H15.5a.5.5 0 0 1-.5-.5V4.707z"
  })]
}), 'Document');
//# sourceMappingURL=index.js.map